"use client";

/**
 * Google Analytics 4 tracking utilities for Next.js landing page
 * Works alongside @next/third-parties/google for enhanced event tracking
 */

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Track a GA4 event
 */
export function trackGAEvent(eventName: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", eventName, params);
}

/**
 * Track page view
 */
export function trackGAPageView(params?: { page_path?: string; page_title?: string }): void {
  trackGAEvent("page_view", params);
}

/**
 * Track form submission (Lead)
 */
export function trackGALead(params?: { form_name?: string }): void {
  trackGAEvent("generate_lead", params);
}

/**
 * Track CTA button click
 */
export function trackGACTAClick(params: { cta_name: string; cta_location?: string }): void {
  trackGAEvent("cta_click", params);
}

/**
 * Track outbound link click
 */
export function trackGAOutboundClick(params: { url: string }): void {
  trackGAEvent("outbound_click", params);
}

/**
 * Track sign up intent (clicking "Get Started" etc.)
 */
export function trackGASignUpIntent(params?: { source?: string }): void {
  trackGAEvent("sign_up_intent", params);
}
